// KPI paket uçlarının yanıt/gövde zarfları (FE istemcisi bu şemalarla ayrıştırır).

import { z } from "zod";
import { KpiPackageItemSchema, KpiPackageSchema } from "./kpi-packages.js";

const Uuid = z.string().uuid();

export const KpiPackageListResponseSchema = z.object({ packages: z.array(KpiPackageSchema) });
export type KpiPackageListResponse = z.infer<typeof KpiPackageListResponseSchema>;

export const KpiPackageMembershipResponseSchema = z.object({
  membership: z.record(Uuid, z.array(Uuid)),
});
export type KpiPackageMembershipResponse = z.infer<typeof KpiPackageMembershipResponseSchema>;

export const KpiPackageDetailResponseSchema = z.object({
  package: KpiPackageSchema,
  items: z.array(KpiPackageItemSchema),
});
export type KpiPackageDetailResponse = z.infer<typeof KpiPackageDetailResponseSchema>;

/** POST /kpi/packages/:id/items gövdesi (TODO-KPI-138). */
export const KpiPackageAddMetricsBodySchema = z.object({
  metricIds: z.array(Uuid).min(1).max(2000),
});
export type KpiPackageAddMetricsBody = z.infer<typeof KpiPackageAddMetricsBodySchema>;

/** POST /kpi/packages/from-set/:setId yanıtı — müşteriye özel / kullanımdan kalkmış göstergeler atlanır. */
export const KpiPackageFromSetResultSchema = z.object({
  package: KpiPackageSchema,
  skippedClientMetrics: z.array(z.object({ metricId: Uuid, label: z.string() })),
  skippedDeprecatedMetrics: z.array(z.object({ metricId: Uuid, label: z.string() })).optional(),
});
export type KpiPackageFromSetResult = z.infer<typeof KpiPackageFromSetResultSchema>;

/** POST /kpi/metrics/:id/promote (dryRun olmayan) yanıtı — backend `KpiPromoteResult` aynası. */
export const KpiPromoteResultSchema = z.object({
  promoted: z.array(z.object({ metricId: Uuid, code: z.string() })),
  rewritten: z.object({
    setFormulas: z.number().int().nonnegative(),
    catalogFormulas: z.number().int().nonnegative(),
    unitTemplates: z.number().int().nonnegative(),
  }),
});
export type KpiPromoteResult = z.infer<typeof KpiPromoteResultSchema>;
